export default "__VITE_ASSET__CdQohGQr__"